import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=3213c4cb&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=3213c4cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3213c4cb",
  null
  
)

export default component.exports